import { render, staticRenderFns } from "./inventory-list.vue?vue&type=template&id=36252d54&scoped=true&"
import script from "./inventory-list.vue?vue&type=script&lang=js&"
export * from "./inventory-list.vue?vue&type=script&lang=js&"
import style0 from "./inventory-list.vue?vue&type=style&index=0&id=36252d54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36252d54",
  null
  
)

export default component.exports